import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "chevron"]

  toggle() {
    this.menuTarget.classList.toggle("hidden")
    this.chevronTarget?.classList.toggle("rotate-180")
  }

  hide(event) {
    if (this.element.contains(event.target)) return

    this.menuTarget.classList.add("hidden")
    this.chevronTarget?.classList.remove("rotate-180")
  }
}
